import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import Title from "../../atoms/Title/Title";
import OptionCard from "../../molecules/OptionCard/OptionCard";
import { SubscriptionOptions } from "../../../types/rtk/subscription/subscription";
import Text from "../../atoms/Text/Text";
import { useAppSelector } from "../../../rtk/_config/hooks";
import { RootState } from "../../../types/rtk/api-config/types";

interface Props {
  datas: SubscriptionOptions[];
}

const OptionChoice = ({ datas }: Props) => {
  const { t } = useTranslation();
  
  useAppSelector((state: RootState) => state.basket.options); 

  return (
    <Box className="OptionChoice">
      <Box className="optionSubtitleContainer">
        <Title
          variant="h1"
          className="optionSubtitle"
          children={t("subscription:SECOND_PAGE.TITLE")}
        />
        <Text
          className="optionTextSubtitle"
          children={t("subscription:SECOND_PAGE.SUBTITLE")}
        />
      </Box>

      <Box className="OptionList">
        {datas.map((obj, i) => (
          <OptionCard
            key={obj.id}
            data={obj}
            index={i}
          />
        ))}
      </Box>
    </Box>
  );
};

export default OptionChoice;
